import { Row } from "antd";
import { GrantAgreementSectionSubHeading } from "../../styles"
import styled from 'styled-components';

export const PaymentLabel = styled(GrantAgreementSectionSubHeading)`
    line-height: ${props => props.theme.lineHeight.secondary};
    margin-bottom: 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
        letter-spacing: ${props => props.theme.letterSpacing.normal};
    }
`
export const PaymentText = styled.div`
    margin-bottom: 30px;
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.heading};
    font-style: normal;
    font-stretch: normal;
    line-height: ${props => props.theme.lineHeight.h4};
    letter-spacing: 0.6px;
    color: ${props => props.theme.fontColors.thead};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin-bottom: 10px;
        font-size: ${props => props.theme.fontSize.secondary};
    }
`

export const PaymentRemover = styled(Row)`
    margin : 30px 0;
`;
